import React from "react"
import { Button } from "reactstrap"

export default function NewReviewsConfirm(props) {
  let { codeData } = props
  console.log("🚀 ~ NewReviewsConfirm ~ codeData:", codeData)
  return (
    <div
      className="review-simple-container review-rcf-sub"
     
    >
      <div className="review-sub-simple-popup">
        <div className="popup-content my-submit-popup">
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <h3 className="highlight review-text-heading">
              Almost Done!
            </h3>
            <p className="review-simple-highlight review-text-submit">
              Complete your review submission by following the confirmation link we've sent to your email.
            </p>
          </div>
          <div className=" d-flex justify-content-center">
            <Button
              className="rcf-submit-btn-sub1"
              style={{
                maxWidth: "90px",
                display: "flex",
                justifyContent: "center",
              }}
              onLoad={() => {
                setTimeout(() => {
               alert("hellllllllloooooooo")
                  window.parent.postMessage({ showRcf: true }, "*")
                  window.location.reload()
                }, 3000)
              }}
              onClick={() => {
                // window.open(`https://${codeData?.merchantId}`, "_blank")
                window.parent.postMessage({ showRcf: true }, "*")
                window.location.reload()
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
